import "./Owner.css";

function Owner() {
  return <div className="owner">owner main</div>;
}

export default Owner;
